import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { removeAllAnswers } from '../utils';

import patternCta from '../assets/images/pattern-cta.png';

import Button from '../components/Button';

const Home = () => {
  const today = localStorage.getItem('today') && parseInt(localStorage.getItem('today'));

  const device = localStorage.getItem('device');

  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    if (device === 'kiosk') localStorage.removeItem('is-played');

    if (device !== 'kiosk' && today !== new Date().getDate()) localStorage.removeItem('is-played');

    localStorage.setItem('today', JSON.stringify(new Date().getDate()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.removeItem('user-info');
    localStorage.removeItem('user-answers');
    removeAllAnswers();
  }, []);

  return (
    <div onClick={() => navigate('/instruction')}>
      <div className="sm:text-[2.8rem] lg:text-8xl text-[2rem] font-bold leading-tight text-center sm:px-40 px-10 sm:py-16 py-2 mt-20 relative z-10">
        <h1>{t('cta2')}</h1>
      </div>

      <Button>{t('takeTheQuiz')}</Button>

      <img src={patternCta} alt="pattern" className="lg:w-full w-[60%] absolute bottom-0 right-0" />
    </div>
  );
};

export default Home;
